import styled, { css } from 'styled-components';
import Drawer from 'antd/es/drawer';
import Input from 'antd/es/input';

import { ItemText } from '@components/ui/search/SearchResultListStyle';
import Button from '@components/Button';

export const Wrapper = styled.div`
  width: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    &:hover {
      border: ${({ theme }) => `1px solid ${theme.palette.black}`};
      cursor: pointer;
      border-radius: 6px;
    }
  }
`;

export const ListItemsWrappedByHeader = styled.div`
  max-height: 300px;
  height: fit-content;
  padding: 20px 0;
`;

export const ItemErrorText = styled(ItemText)`
  color: ${({ theme }) => theme.palette.tomato};
  font-size: 14px;
`;

export const ResponsiveSearchDrawerItemContent = styled.div<{
  hasError: boolean;
}>`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.grey200};
  background: ${({ theme }) => theme.palette.white};
  min-height: 56px;

  &.border-bottom-hidden {
    border-bottom: none;
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid ${({ theme }) => theme.palette.errorColor};
      animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97);
    `}

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;

export const ResponsiveSearchDrawerItemLabel = styled.span<{
  isFilled?: boolean;
}>`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme, isFilled }) =>
    isFilled ? theme.palette.grey1100 : theme.palette.grey800};
  display: flex;
  flex: 1;
`;

export const ListingSearchInput = styled(Input)`
  &&& {
    display: flex;
    padding: 6px 12px;
    align-items: center;
    align-self: stretch;
    border-radius: 4px;
    border: ${({ theme }) => `1px solid ${theme.palette.grey200}`};
    background: ${({ theme }) => theme.palette.white};

    &.setur-input-affix-wrapper-focused {
      box-shadow: none;
    }

    .setur-input-prefix {
      margin-inline-end: 12px;
    }

    .setur-input {
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      color: ${({ theme }) => theme.palette.grey1100};

      &::placeholder {
        color: ${({ theme }) => theme.palette.grey800};
      }
    }
  }
`;

export const ResponsiveListingSearchLocationSelect = styled.div`
  padding: 16px 16px 0px;
`;

export const ResponsiveLocationDrawerContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ResponsiveLocationItems = styled.div`
  padding: 16px 24px 24px 24px;
  width: 100%;
  height: fit-content;
  height: 100%;
  overflow: auto;
  z-index: 999999999;
  transition: all 0.5s;
  flex: 1;
`;

export const ResponsiveLocationListItem = styled.div`
  display: flex;
  align-items: center;
`;

export const ResponsiveLocationListItemContent = styled(Button).attrs({
  type: 'link',
})`
  &&& {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    position: relative;
    padding: 0px !important;
    height: auto !important;
    min-height: 48px;

    &:hover,
    &:focus {
      background: none;
      box-shadow: none;
    }
  }
`;

export const ResponsiveLocationListItemIcon = styled.div`
  margin-right: 12px;
`;

export const ResponsiveLocationListItems = styled.div`
  width: 100%;
  height: 100%;
`;

export const ResponsiveLocationListItemText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.palette.grey1100} !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 16px !important;

  b {
    font-weight: 600 !important;
  }
`;

export const ResponsiveSearchDrawerButton = styled(Button)`
  width: 100%;
  display: block;
  font-weight: bold;
`;

export const ResponsiveSearchDrawerButtonWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 15px;
  box-shadow: 0 10px 40px 0 rgba(58, 58, 58, 0.2);
  background-color: ${({ theme }) => theme.palette.white};
`;

export const StyledListingLocationDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-body {
      padding: 0 0;
    }

    .setur-drawer-header {
      display: flex;
      padding: 18px 16px;
      align-items: center;
      gap: 24px;
      min-height: 60px;
      background: ${({ theme }) => theme.palette.grey1100};

      .setur-drawer-close {
        margin-inline-end: 0px;
        padding: 0px;
      }
    }

    .setur-drawer-header-title {
      flex-direction: row-reverse;
    }

    .setur-drawer-title {
      color: ${({ theme }) => theme.palette.white};
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
    }

    .select-content {
      min-width: 100%;
    }

    .select-text-content {
      width: 100%;
    }
    .select-text {
      width: 100%;
    }

    .select-input {
      width: 100%;
    }
  }
`;
